import { graphql } from '@/generated';
export const deleteSitesMutation = graphql(`
  mutation deleteSites($ids: [uuid!]!, $auditLogInput: AuditLogInsertInput!) {
    deleteSite(where: { id: { _in: $ids } }) {
      affectedRows
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const createCustomerMutation = graphql(`
  mutation createCustomer(
    $input: CustomerInsertInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    insertCustomerOne(object: $input) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const createSiteMutation = graphql(`
  mutation createSite(
    $inputs: SiteInsertInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    insertSiteOne(object: $inputs) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const updateCustomerMutation = graphql(`
  mutation updateCustomer(
    $pkColumnInput: CustomerPkColumnsInput!
    $setInput: CustomerSetInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    updateCustomerByPk(pkColumns: $pkColumnInput, _set: $setInput) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const createDeviceInBulkMutation = graphql(`
  mutation createDeviceInBulk(
    $deviceInsertInputs: [DeviceInsertInput!]!
    $siteInsertInputs: [SiteInsertInput!]!
    $auditLogInput: AuditLogInsertInput!
  ) {
    insertSite(objects: $siteInsertInputs) {
      affectedRows
    }
    insertDevice(objects: $deviceInsertInputs) {
      returning {
        id
      }
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const deleteCustomerMutation = graphql(`
  mutation deleteCustomer($id: uuid!, $auditLogInput: AuditLogInsertInput!) {
    deleteCustomerByPk(id: $id) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const upsertCustomerS3BucketMutation = graphql(`
  mutation upsertCustomerS3Bucket(
    $customerId: UUID!
    $auditLogInput: AuditLogInsertInput!
  ) {
    upsertCustomerS3Bucket(input: { customerId: $customerId })
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const createCustomerApiKeysMutation = graphql(`
  mutation createCustomerApiKeysMutation(
    $input: CreateCustomerApiKeysInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    createCustomerApiKeys(input: $input) {
      apiKeys {
        customerId
        key
        reference
        roleId
      }
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);
